export interface AccountPostalCodePayload {
  accountNumber: string;
  postalCode: string;
}

export interface EmailPostalCodePayload {
  email: string;
  postalCode: string;
}

export interface NameAddressPayload {
  firstName: string;
  lastName: string;
  address1: string;
  address2: string;
  city: string;
  state: string;
  postalCode: string;
  country: string;
  captureEmail: string;
  emailOptIn: string;
}
export type IMessage = {
  type: string;
  text: string;
};

export enum LoginTabs {
  accountPostalCode = 'accountNumberPostalCode',
  emailPostalCode = 'emailPostalCode',
  nameAndAddress = 'nameAddress',
}
